const initialState = {
  data: {}
};


function System(state = initialState, action) {
  let newState = {...state};
  switch (action.type) {
    case 'UPDATE_SYSTEM_INFO':
      newState.data = action.data
      return newState;
      break;
    default:
      return state;
  }
}

export {System}



// WEBPACK FOOTER //
// ./reducers/system.js